import {
    FieldInCard,
} from 'app/types/form.types'
import {
    OrderStepFields,
} from 'app/Apps/OrderManagement/Orders/orders.types'

const getInternalCustomsFormFields = ({
    locationId,
    exists,
}: {
    locationId: number,
    exists: boolean,
}): FieldInCard<OrderStepFields>[] => {
    return [
        {
            id: 'column1',
            fields: [
                {
                    name: 'forwarder',
                    componentName: 'FreightForwarderSelector',
                    labelKey: 'Location.forwarder',
                },
                {
                    name: 'forwarderContacts',
                    componentName: 'MultipleContactObjectSelector',
                    labelKey: 'Location.forwarderContacts',
                },
            ],
        },
        {
            id: 'column2',
            fields: [
                {
                    name: 'location',
                    componentName: 'LocationObjectSelector',
                    labelKey: 'OrderStep.location',
                },
                {
                    name: 'locationContacts',
                    componentName: 'MultipleContactByLocationObjectSelector',
                    labelKey: 'OrderStep.locationContacts',
                    existedForm: exists,
                    selectedLocation: locationId,
                },
            ],
        },
        {
            id: 'column3',
            fields: [{
                name: 'comment',
                componentName: 'LongText',
                labelKey: 'OrderStep.comment',
            }],
        },
    ]
}

export default getInternalCustomsFormFields
